import { TagMonsterChild } from "./TagMonsterChild";

export default TagMonsterChild;
